import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Coupon = ApplicationRecord.extend({
  static: {
    jsonapiType: 'coupons',
  },
  attrs: {
    active: attr(),
    availableGrades: attr(),
    availableSchools: attr(),
    code: attr(),
    couponType: attr(),
    endDate: attr(),
    value: attr(),
    flatValue: attr({ persist: false }),
    daysPostJob: attr({ persist: false }),
    daysPostJobStart: attr({ persist: false }),
    promoHeadline: attr({ persist: false }),
    promoSubhead: attr({ persist: false }),
    expiresOn: attr({ persist: false }),
    useInOrderFlow: attr({ persist: false }),
    imageUrl: attr(),
    // The add-ons a FREE_ADDON_CHOICE offer lets the parent pick from (#5747):
    // an array of plain objects with the SAME camel-case keys an Addon record
    // has (cssName, imageUrl, backgroundSelection, allowsJpgPoses, ...), so the
    // gifts renderer and poseEligibility read them unchanged. Empty otherwise.
    freeAddons: attr({ persist: false }),
    // What to call the free item, typed on the coupon screen (#5747); blank
    // means derive it from the set. See offerPricing.js freeItemLabel.
    freeItemLabel: attr({ persist: false }),
    // A different percent per package (PERCENTAGE_PER_OPTION): the overrides
    // keyed by option id, and the DERIVED "save up to" maximum. spraypaint
    // drops any attribute not declared here -- the cards silently fell back to
    // the base percent and the banner to "up to 20%" until these were listed
    // (found on the live page, 2026-10-21). See offerPricing.js percentFor.
    tiered: attr({ persist: false }),
    optionPercents: attr({ persist: false }),
    maxPercentOff: attr({ persist: false }),
    // Free shipping over a subtotal: the minimum the offer starts at, for the
    // banner ("on orders over $50") and the card-level claim (waivesShippingAt).
    freeShippingMinimum: attr({ persist: false }),
  },
});

export default Coupon;
